import { render } from "./form-autocomplete.vue?vue&type=template&id=afefae3c"
import script from "./form-autocomplete.vue?vue&type=script&lang=js"
export * from "./form-autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__